import triggerCustomGaEvent from '../analytics/triggerCustomGaEvent'

export default function tripTeaseHotelSearch(startDateVal, endDateVal, adultsVal, childrenVal, numRoomsVal) {
	const tripTeaseSearchData = {
		"@context": "https://structured-data.triptease.io",
		"@type": "LodgingSearch",
		"checkinTime": startDateVal.toString(),
		"checkoutTime": endDateVal.toString(),
		"numAdults": adultsVal.toString(),
		"numChildren": childrenVal.toString(),
		"numRooms": numRoomsVal.toString()
	}
	triggerCustomGaEvent('triptease-search', tripTeaseSearchData)
}


// WEBPACK FOOTER //
// ./src/utilities/tripTease/tripTeaseHotelSearch.js